import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Img, Text } from "components";
import { useNavigate } from "react-router-dom";

const CartEmpty = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-[#FFF8F7] max-w-[1110px] flex flex-col items-center justify-center w-full md:px-4 py-12 my-auto h-full rounded mt-12">
        <Img
          className="h-[264px] w-[248px] object-cover sm:h-[153px] sm:w-[144px]"
          src="images/Emptybucket.png"
          alt="group36102"
        />
        <Text
          className="mt-5 text-[32px] leading-[48px] font-semibold text-center sm:text-[24px]"
          style={{
            color: "var(--Blacks-900, #1A1A1A)",
            fontFamily: "Unbounded",
            fontStyle: "normal",
          }}
        >
          {t("yourCartIsEmpty")}
        </Text>
        <Text
          className="mt-2 text-[20px] leading-[28px] font-normal text-center w-[50%] sm:w-full sm:text-[14px]"
          style={{
            color: "var(--Blacks-400, #727783)",
            fontFamily: "Inter",
            fontStyle: "normal",
          }}
        >
          {t("planningAPartyOrJust")}
        </Text> 
        <Button
          className="common-pointer bg-[#771237] hover:border cursor-pointer font-['Unbounded'] h-12 mt-10 py-3.5 rounded-full text-base text-center text-white-A700 w-[180px] mb-5 sm:w-full"
          hover={true}
          onClick={(e) => {
            navigate("/all-products");
          }}
        >
          {t("shopNow")}
        </Button>
      </div>
    </>
  );
};

export default CartEmpty;